import { SensorConfigFormShape } from '@Types/configurations.types';
import { SystemConnection } from '@Types/systemConnections.types';
import { SensorConnectPeek } from '@Utils/sensorPeekQueryBuilder';

export type PeekRequest = {
	formData: SensorConfigFormShape;
	sysConnection: SystemConnection;
};

export class ConnectionPeeker {
	private constructor() {
		// ? noop
	}

	private static odbcQuery(
		form: SensorConfigFormShape,
		sysConnection: SystemConnection,
	) {
		const sensorConnectionPeek = new SensorConnectPeek();
		return sensorConnectionPeek
			.withSystemConnection(sysConnection)
			.createQuery(form);
	}

	public static create(request: PeekRequest) {
		const { formData, sysConnection } = request;
		switch (sysConnection.connectionType) {
			case 'ODBC':
			case 'OLEDB':
				return ConnectionPeeker.odbcQuery(formData, sysConnection);
			// TODO: opcua here...
			default:
				return 'invalid connection type';
		}
	}
}
